import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import './styles.css';

import CommunicateLink from '../../shared/CommunicateLink';
import SendToAdmissions from '../../../components/SendToAdmissions';

const messages = defineMessages({
  getInTouch: {
    id: 'hubs.overview.contact-info.get-in-touch',
    defaultMessage: 'Get in touch with',
  },
  appMailingAdd: {
    id: 'hubs.overview.contact-info.appMailingAddress',
    defaultMessage: 'Application Mailing Address',
  },
  admissions: {
    id: 'hubs.overview.contact-info.admissions',
    defaultMessage: 'Admissions',
  },
});

class ContactInfo extends React.PureComponent {
  static propTypes = {
    overviewData: PropTypes.object,
    premium_links: PropTypes.array,
    userData: PropTypes.object,
    collegeContact: PropTypes.array,
    sendEmail: PropTypes.func,
    collegeName: PropTypes.func,
    isCamino: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      showAdmissionsModal: false,
    };
  }

  openAdmissionsModal = () => {
    this.setState({
      showAdmissionsModal: true,
    });
  };

  closeAdmissionsModal = () => {
    this.setState({
      showAdmissionsModal: false,
    });
  };

  render() {
    const {
      overviewData,
      premium_links,
      userData,
      collegeContact,
      sendEmail,
      isCamino,
    } = this.props;

    if (!overviewData) {
      return null;
    }

    const { showAdmissionsModal } = this.state;

    const {
      schoolName,
      applicationMailingAddress,
      admissionsOffice,
      financialAid,
    } = overviewData;

    const street1 = get(applicationMailingAddress, 'street1.value', '');
    const street2 = get(applicationMailingAddress, 'street2.value', '');
    const city = get(applicationMailingAddress, 'city.value', '');
    const state = get(applicationMailingAddress, 'state.value', '');
    const zip = get(applicationMailingAddress, 'zip.value', '');

    const userEmail = get(userData, 'emailAddress', '');
    const admissionsDefaultValue = isCamino ? '_' : '';
    const phoneNumber = get(
      admissionsOffice,
      'phoneNumber.value',
      admissionsDefaultValue,
    );
    const faxNumber = get(admissionsOffice, 'fax.value', admissionsDefaultValue);
    const financialAidNumber = get(financialAid, 'phoneNumber.value', '');
    const admissionsEmail = get(admissionsOffice, 'email.value', '');

    return (
      <div
        data-cy="contact-info-container"
        className="contact-info-container common-core-width"
      >
        <div className="contact-info-core">
          <div className="contact-school">
            <h3 className="contact-school-name">
              <FormattedMessage {...messages.getInTouch} /> {get(schoolName, 'value', '')}
            </h3>
            {!isCamino && (
              <div className="contact-communicate">
                <CommunicateLink
                  className="college-address-footer-format"
                  premium_links={premium_links}
                  collegeContact={collegeContact}
                  collegeName={get(schoolName, 'value', '')}
                  userEmail={userEmail}
                  openAdmissionsModal={this.openAdmissionsModal}
                  sendEmail={sendEmail}
                />
              </div>
            )}
          </div>
          <div className="address-container">
            <div className="application-address-container">
              <h4>
                <FormattedMessage {...messages.appMailingAdd} />
              </h4>
              <div data-navi-donottranslate>{get(schoolName, 'value', '')}</div>
              <div>Attn: Applications</div>
              {street1 && <div>{street1}</div>}
              {street2 && <div>{street2}</div>}
              {city && state && zip && (
                <div>
                  {city} {state}, {zip}
                </div>
              )}
            </div>
            <div className="admissions-container">
              <h4>
                <FormattedMessage {...messages.admissions} />
              </h4>
              <div>Phone: {phoneNumber ? phoneNumber : admissionsDefaultValue}</div>
              <div>Fax: {faxNumber ? faxNumber : admissionsDefaultValue}</div>
              <div>
                Financial Aid:{' '}
                {financialAidNumber ? financialAidNumber : admissionsDefaultValue}
              </div>
              <div>
                E-mail: {admissionsEmail ? admissionsEmail : admissionsDefaultValue}
              </div>
            </div>
          </div>
          <SendToAdmissions
            open={showAdmissionsModal}
            onClose={this.closeAdmissionsModal}
            userEmail={userEmail}
            admissionsOffice={admissionsOffice}
            sendEmail={sendEmail}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(ContactInfo);
